import { printFooterText } from "@/constants";
import styles from "./index.module.scss";

const PrintFooter = ({ locale = "en" }) => {
  return (
    <div className={styles.printFooter}>
      {locale === "en" ? (
        <p className="text-[12px]">
          <strong className="text-[15px]">
            {printFooterText.questionsText[locale]}
          </strong>{" "}
          Visit Us at{" "}
          <a
            href="https://www.kohler.co.th"
            target="_blank"
            rel="noopener noreferrer"
          >
            www.kohler.co.th
          </a>
        </p>
      ) : (
        <p>
          <strong className="text-[15px]">
            {printFooterText.questionsText[locale]}
          </strong>{" "}
          <a
            href="https://www.kohler.co.th"
            target="_blank"
            rel="noopener noreferrer"
          >
            www.kohler.co.th
          </a>
        </p>
      )}
      <p className="text-[12px]">{printFooterText.copyrightText[locale]}</p>
    </div>
  );
};

export default PrintFooter;
